var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { shadow: _vm.isPopupOpen }, style: { marginBottom: "10px" } },
    [
      _c("div", { staticClass: "table-row camp-row" }, [
        _c("div", { staticClass: "td order-0 order-lg-0" }, [
          _c("div", { staticClass: "tools" }, [
            !_vm.readonly && _vm.accessibleItems.length
              ? _c(
                  "div",
                  { staticClass: "checkbox-wrapper" },
                  [
                    _c("checkbox", {
                      directives: [
                        {
                          name: "select",
                          rawName: "v-select",
                          value: _vm.campId,
                          expression: "campId"
                        }
                      ],
                      attrs: { checked: _vm.checked }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showMobileVersion
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center"
                  },
                  [
                    _vm.pricings.length
                      ? _c("img", {
                          class: [
                            "down-arrow",
                            _vm.isPopupOpen ? "rotatedBack" : "rotated"
                          ],
                          attrs: {
                            src: require("../../../../assets/img/opened.svg")
                          },
                          on: { click: _vm.togglePopup }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.readonly
                      ? _c("options", {
                          staticClass: "ml-auto",
                          attrs: { options: _vm.accessibleItems }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "td order-1 order-lg-1 cursor-pointer name font-weight-bold text-truncate",
            attrs: { title: _vm.campName }
          },
          [
            _c("div", { staticClass: "text-truncate" }, [
              _vm._v(_vm._s(_vm.campName))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "td order-4 order-lg-2" },
          [
            _c("day-picker", {
              attrs: {
                width: "33px",
                height: "22px",
                readonly: true,
                value: _vm.daysList
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "td order-3 order-lg-3 cursor-pointer text-truncate",
            attrs: { title: _vm.location }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "text-truncate" }, [
              _vm._v(_vm._s(_vm.location))
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "td order-2 order-lg-4" }, [
          _c("div", [_vm._v(_vm._s(_vm.localStartDate))]),
          _vm._v(" "),
          _vm.showMobileVersion
            ? _c("div", { staticClass: "delimiter mx-1" }, [_vm._v(" - ")])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [_vm._v(_vm._s(_vm.localEndDate))])
        ]),
        _vm._v(" "),
        !_vm.showMobileVersion
          ? _c("div", { staticClass: "td order-lg-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center"
                },
                [
                  _vm.pricings.length
                    ? _c("img", {
                        class: [
                          "down-arrow",
                          _vm.isPopupOpen ? "rotatedBack" : "rotated"
                        ],
                        attrs: {
                          src: require("../../../../assets/img/opened.svg")
                        },
                        on: { click: _vm.togglePopup }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readonly
                    ? _c("options", {
                        staticClass: "ml-auto",
                        attrs: { options: _vm.accessibleItems }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.isPopupOpen
            ? _c("camp-pricings-list", {
                attrs: {
                  readonly: _vm.readonly,
                  "camp-id": _vm.campId,
                  pricings: _vm.pricings
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "mobile-title mr-2" }, [
      _c("img", {
        staticClass: "location-img",
        attrs: { src: require("../../../../assets/img/map-pin.png") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-266452ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-266452ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camps/CampRow.vue
// module id = null
// module chunks = 